// extracted by mini-css-extract-plugin
export default {"price":"Y8-z","priceRow":"Z8-z","onSale":"_8-z","msrpLabelPrice":"a9-z","msrpLabel":"b9-z","originalPrice":"c9-z","percentOff":"d9-z"};